import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Message {
  id: string;
  conversationId: string;
  sender: string;
  text: string;
  timestamp: number;
  read: boolean;
}

export interface Conversation {
  id: string;
  patientId: number;
  contactName: string;
  lastMessage: string;
  lastMessageTime: number;
  unreadCount: number;
  messages: Message[];
}

interface MessagesState {
  conversations: Conversation[];
  selectedConversation: string | null;
  loading: boolean;
}

const initialState: MessagesState = {
  conversations: [],
  selectedConversation: null,
  loading: false,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setConversations: (state, action: PayloadAction<Conversation[]>) => {
      state.conversations = action.payload;
    },
    setSelectedConversation: (state, action: PayloadAction<string | null>) => {
      state.selectedConversation = action.payload;
    },
    addMessage: (state, action: PayloadAction<{ conversationId: string; message: Message }>) => {
      const conversation = state.conversations.find(
        (c) => c.id === action.payload.conversationId
      );
      if (conversation) {
        conversation.messages.push(action.payload.message);
        conversation.lastMessage = action.payload.message.text;
        conversation.lastMessageTime = action.payload.message.timestamp;
      }
    },
    markAsRead: (state, action: PayloadAction<string>) => {
      const conversation = state.conversations.find((c) => c.id === action.payload);
      if (conversation) {
        conversation.unreadCount = 0;
        conversation.messages.forEach((m) => {
          m.read = true;
        });
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setConversations,
  setSelectedConversation,
  addMessage,
  markAsRead,
  setLoading,
} = messagesSlice.actions;

export default messagesSlice.reducer;

